import api from '@/services/api';
export default {
    async getContractsWithCompanyInfo({dispatch, commit}, params) {
        params = params ? params : { page: 1, limit: 10 };
        const {data} = await api.get('/api/contract/getContractsWithCompanyInfo', {params});
        if (data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_CONTRACTS', data.data);
        }
        return data;
    },
    async getActivedCourseStatics({dispatch, commit}, contractId) {
        let params = {contractId}
        const {data} = await api.get('/api/employee/getActiveCourseStatics', {params});
        if (data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_CONTRACTS', data.data);
        }
        return data;
    },
    async getContractDetail({dispatch, commit}, contractId) {
        let params = { _id: contractId };
        let response = await api.get('/api/contract/getContractDetailInfo', { params }).catch(error => {
            console.warn(error)
        });
        if(!response.data.success) {
            return null;
        }
        return response.data.data.contract_detail;
    },
    async getUserProcessOverviewStatics({dispatch, commit}, params) {
        const {data} = await api.get('/api/userProcess/getUserProcessOverviewStatics', {params});
        return data;
    },
    async getUserProcessDetailStatics({dispatch, commit}, params) {
        const {data} = await api.get('/api/userProcess/getUserProcessDetailStatics', {params});
        if(data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_USER_PROCESS_DETAIL_DATA', data.data);
        }
        return data;
    },
    async getQuizResultsByContract({dispatch, commit}, params) {
        const {data} = await api.get('/api/quizResult/getQuizResultsByContract', {params});
        if(data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_QUIZ_RESULTS', data.data);
        }
        return data;
    },
    async getProcessStaticsByEmployee({dispatch, commit}, params) {
        const {data} = await api.get('/api/userProcess/getProcessStaticsByEmployee', {params});
        if(data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_USER_PROCESS_DETAIL_DATA', data.data);
        }
        return data;
    },
    async getResultStaticsByEmployee({dispatch, commit}, params) {
        const {data} = await api.get('/api/quizResult/getResultStaticsByEmployee', {params});
        return data;
    },
    async getNativeCoursesDataInContract({dispatch, commit}, params) {
        const {data} = await api.get('/api/userProcess/get-native-data-in-contract', {params});
        if (data.success) {
            let returnData = data.data;
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_USER_PROCESS_DETAIL_DATA', returnData);
            return returnData;
        }
        return data;
    },
    async exportResultsData({dispatch, commit}, params) {
        const data = await api.get(`/api/quizResult/export-results-in-contract`, {params, responseType: 'blob'}).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data],{type:headers['content-type']}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Report.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async exportProcessStaticsByContract({dispatch, commit}, params) {
        const data = await api.get(`/api/userProcess/export-process-in-contract`, {params, responseType: 'blob'}).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data],{type:headers['content-type']}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Report.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async exportNativeDetailByContract({dispatch, commit}, contractId) {
        let params = {contractId}
        const data = await api.get(`/api/userProcess/export-native-detail-in-contract`, {params, responseType: 'blob'}).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data],{type:headers['content-type']}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Report.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getAttendanceResultsByContract({ dispatch, commit }, params) {
        const { data } = await api.get('/api/attendances', { params });
        return data;
    },
    async importAttendances({ dispatch, commit }, importData) {
        const { data } = await api.post('/api/attendances/import', importData);
        return data;
    },
    async exportAttendanceResultsData({ dispatch, commit }, params) {
        const data = await api.get(`/api/attendances/export`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'AttendanceReport.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async exportCompanyDetailResults({ dispatch, commit }, params) {
        const data = await api.get(`/api/userProcess/export-company-process`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'DetailReport.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async exportCompanyQuizResults({ dispatch, commit }, params) {
        const data = await api.get(`/api/quizResult/export-results-in-company`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'QuizResults.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async exportCompanyAttendanceResults({ dispatch, commit }, params) {
        const data = await api.get(`/api/attendances/export-by-company`, { params, responseType: 'blob' }).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data], { type: headers['content-type'] }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'AttendanceReport.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getCompanyDetailStatics({ dispatch, commit }, params) {
        const { data } = await api.get('/api/userProcess/companies-process', { params });
        if (data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
            commit('SET_USER_PROCESS_DETAIL_DATA', data.data);
        }
        return data;
    },

    async getCourses({ dispatch, commit }, params) {
        const { data } = await api.get('/api/courses', { params });
        if (data.success) {
            let courses = ['all', ...data.data.list.map(item => { return item.permission_id })]
            commit('SET_COURSES', courses);
        }
        return data;

    },

    async getGogaResultsByContract({dispatch, commit}, params) {
        const {data} = await api.get('/api/quizResult/getGogaResultsByContract', {params});
        if(data.success) {
            commit('SET_NUMBER_OF_RESULTS', data.numberOfResults);
        }
        return data;
    },
    async exportGogaResults({dispatch, commit}, params){
        const data = await api.get(`/api/quizResult/getGogaResultsByContract`, {params, responseType: 'blob'}).then(response => {
            let headers = response.headers;
            const url = window.URL.createObjectURL(new Blob([response.data],{type:headers['content-type']}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Report.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    async getGogaLearningData({dispatch, commit}, params) {
        const {data} = await api.get('/api/userProcess/getGogaLearningData', {params});
        return data;
    },
}